import React, { Component } from "react";
import { CRUDFunction } from "../../../reduxCURD/container";
import "./SystemAppForms.css";
import { toast } from "react-toastify";
import { isJSON } from "../../../utils/isJson";
import { FixedAppLookupsContext } from "../../FixedAppLookupsProvider";
import { Button } from "reactstrap";
import { ic_keyboard_arrow_right } from "react-icons-kit/md/ic_keyboard_arrow_right";
import { ic_keyboard_arrow_down } from "react-icons-kit/md/ic_keyboard_arrow_down";
import Icon from "react-icons-kit";
import { CommonTabs } from "../../TabBarCompoenent/CommonTabs";
import AppFormVariationSection from "./AppFormVariations";
class Systemappforms extends Component {
  constructor(props) {
    super(props);

    this.state = { systemAppForms: [], appFormVariations: [], selectedTab: 0 };
    this.actionItems = this.actionItems.bind(this);
    this.showToastInfo = this.showToastInfo.bind(this);
    this.showToastError = this.showToastError.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
  }

  showToastInfo(message) {
    toast.success(message, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }

  showToastError(message, error) {
    let toastMessage = message + ": " + error;
    if (!error) {
      toastMessage = message;
    }

    toast.error(toastMessage, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }

  componentDidMount() {
    this.handleRefresh();
  }

  handleRefresh() {
    this.props.getSystemAppForms("getSystemAppForms");
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.actionType !== prevProps.actionType && this.props.actionType === "SYSTEMAPPFORMS_READ_SUCCESS") {
      this.setState({
        systemAppForms: [...this.props.systemAppForms.filter((form) => form.name !== "Form Variations")],
        appFormVariations: [...this.props.systemAppForms.filter((form) => form.name === "Form Variations")],
      });
    }
    if (
      this.props.actionType !== prevProps.actionType &&
      (this.props.actionType === "SYSTEMAPPFORM_UPDATE_SUCCESS" || this.props.actionType === "SYSTEMAPPFORM_CREATE_SUCCESS")
    ) {
      this.showToastInfo(this.props.systemAppForm && this.props.systemAppForm.message);
    }
    if (
      this.props.actionType !== prevProps.actionType &&
      (this.props.actionType === "SYSTEMAPPFORM_UPDATE_FAILURE" || this.props.actionType === "SYSTEMAPPFORM_CREATE_FAILURE")
    ) {
      this.showToastError("Error: Form might not exist in database for update or linked to assettypes in case of deletion");
    }
  }
  isValidCode(code) {
    const pattern = /^[a-zA-Z0-9_-]+$/;

    // Check if code is a string and matches the pattern
    return typeof code === "string" && pattern.test(code);
  }

  actionItems(action, appForm) {
    if (action === "create") {
      let valid = this.isValidCode(appForm.code);
      if (!valid) {
        this.showToastError("Error: Invalid Form Code.");
        return;
      }
    }
    let methods = {
      create: () => this.props.createSystemAppForm(appForm),
      update: () => this.props.updateSystemAppForm(appForm, "updateSystemAppFormDB"),
      delete: () => this.props.updateSystemAppForm(appForm, "removeSystemAppFormDB"),
    };
    methods[action] && methods[action]();
  }

  render() {
    let sections =
      this.state.systemAppForms &&
      this.state.systemAppForms.map((section) => <RenderFormSection key={section.name} section={section} actionItems={this.actionItems} />);

    return (
      <div className={"systemAppFormSectionContainer"}>
        <div style={{ marginBottom: "10px" }}>
          <CommonTabs
            tabs={[
              { id: 0, label: "Forms" },
              { id: 1, label: "Variations" },
            ]}
            onTabChange={(tab) => {
              this.setState({ selectedTab: tab.id });
            }}
            selectedTab={this.state.selectedTab}
          />
        </div>
        {this.state.selectedTab === 0 && sections}
        {this.state.selectedTab === 1 && (
          <AppFormVariationSection
            key={this.state.appFormVariations[0].name}
            section={this.state.appFormVariations[0]}
            actionItems={this.actionItems}
            refresh={this.handleRefresh}
          />
        )}
      </div>
    );
  }
}

const SystemAppFormsContainer = CRUDFunction(Systemappforms, "systemAppForm", null, null, null, "applicationlookups/systemAppForms");
export default SystemAppFormsContainer;

class RenderFormSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItem: null,
      searchStr: "",
      isCollapsed: false,
    };
  }

  toggleCollapse = () => {
    this.setState((prevState) => ({ isCollapsed: !prevState.isCollapsed }));
  };

  render() {
    const { appForms, refreshLookups } = this.context;
    const { props } = this;
    const { searchStr, isCollapsed } = this.state;
    const lowerCaseSearchStr = searchStr.toLowerCase();
    let sectionHeading = props.section && props.section.name;
    let appFormCodes = appForms.map((form) => form.code);

    const filteredForms = props.section
      ? props.section.forms.filter(
          (form) =>
            !searchStr ||
            form.code.toLowerCase().includes(lowerCaseSearchStr) ||
            form.description.toLowerCase().includes(lowerCaseSearchStr),
        )
      : [];

    let formEntries = filteredForms.map((form, index) => {
      const key = `${form.code}-${index}`;
      return (
        <AppFormItem
          key={key}
          selected={this.state.selectedItem === key}
          form={form}
          appFormCodes={appFormCodes}
          actionItems={props.actionItems}
          onClick={() => this.state.selectedItem !== key && this.setState({ selectedItem: key })}
        />
      );
    });

    return (
      <div className="systemAppForms">
        <h2>
          {sectionHeading} <Button onClick={(e) => refreshLookups(["appForms"])}>Refresh</Button>
          <Button style={{ marginLeft: "5px" }} onClick={this.toggleCollapse}>
            <Icon icon={isCollapsed ? ic_keyboard_arrow_right : ic_keyboard_arrow_down} size={20} />
          </Button>
        </h2>
        {!isCollapsed && (
          <div>
            <div style={{ marginBottom: "10px" }}>
              <input
                value={searchStr}
                placeholder={`Search ${sectionHeading}`}
                onChange={(e) => this.setState({ searchStr: e.target.value })}
              />
              <span style={{ padding: "0 10px" }}>{`Found ${filteredForms.length} records`}</span>
            </div>
            <table>
              <thead className="systemAppForms-header">
                <tr>
                  <th>Code</th>
                  <th>Description</th>
                  <th>Tags</th>
                  <th>Actions</th>
                  <th>Exists</th>
                </tr>
              </thead>
              <tbody className="systemAppForms-body">{formEntries}</tbody>
            </table>
          </div>
        )}
      </div>
    );
  }
}

RenderFormSection.contextType = FixedAppLookupsContext;

const AppFormItem = (props) => {
  return (
    <tr className={`${props.selected ? "selected" : ""}`} onClick={props.onClick}>
      <td style={{ minWidth: "350px", width: "500px" }}> {props.form.code}</td>
      <td style={{ minWidth: "350px", width: "500px" }}>{props.form.description}</td>
      <td style={{ minWidth: "150px" }}>{props.form.tags}</td>
      <td style={{ minWidth: "325px" }}>
        <span onClick={(e) => props.actionItems("create", props.form)}>Add</span>
        <span onClick={(e) => props.actionItems("update", props.form)}>Update opt1</span>
        <span onClick={(e) => props.actionItems("delete", props.form)}>Remove</span>
      </td>
      <td style={{ minWidth: "100px" }}>{props.appFormCodes.includes(props.form.code) ? "Yes" : ""}</td>
    </tr>
  );
};



// WEBPACK FOOTER //
// ./src/components/diagnostics/SystemAppForms/SystemAppForms.js